import { Fragment, useContext, useMemo } from "react";
import { UBButton, ParagraphText, UBInput } from "../../../../Libraries";
import { FileAttachment, TitleAndActionBox } from "../../../common";
import { Box, Grid } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import BusinessLoader from "../../../common/BusinessLoader";
import { EnterIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./IncreaseLimitForm.module.css";

const NTN_MIN_LENGTH = 7;
const NTN_MAX_LENGTH = 13;

const IncreaseLimitForm = ({
  loadingAccountLimit,
  files,
  setFiles,
  ntnNumber,
  setNtnNumber,
  loadingIncreaseLimit,
  onBack,
  onSubmit,
}) => {
  const [I18n] = useContext(LanguageContext);
  const isDisabled = !Boolean(files.length);

  const ntnError = useMemo(() => {
    if (!ntnNumber) return "";
    if (ntnNumber.length < NTN_MIN_LENGTH || ntnNumber.length > NTN_MAX_LENGTH) {
      return I18n.ntn_number_length;
    }
    return "";
  }, [ntnNumber, I18n]);

  return (
    <Fragment>
      <BusinessLoader loadBusiness={loadingAccountLimit || loadingIncreaseLimit} />
      <Grid
        container
        className={`${formStyles.root} ${formStyles.SaleExpenseFormWrapper} ${styles.wrapper} ${styles.page} accountLimitScreen`}
      >
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: "increase_limit",
              isBack: true,
              onBack,
              id: "account_limit",
            }}
          />
          <Box className={styles.shell}>
            <Box className={styles.column}>
              <ParagraphText className={`fontSize14 ${styles.uploadTitle}`}>
                {I18n.upload_electricity_or_gas_bill_to_increase_limit}
              </ParagraphText>

              <FileAttachment
                id="account_limit_file"
                filesPath={files}
                setFilesPath={setFiles}
                variant="billUpload"
                handleLogEvent={() =>
                  triggerLogEvent(analytics, "w_acc_limit_file_attach")
                }
                handleRemoveLogEvent={() =>
                  triggerLogEvent(analytics, "w_acc_limit_file_remove")
                }
              />

              {!isDisabled ? (
                <Box className={styles.ntnFieldWrap}>
                  <UBInput
                    id="account_limit_ntn_input"
                    label={I18n.ntn_number}
                    placeholder={I18n.enter_ntn_number}
                    onChange={(_, val) => setNtnNumber(val)}
                    value={loadingIncreaseLimit ? "" : ntnNumber}
                    disabled={loadingIncreaseLimit}
                    baseClassname={styles.ntnInput}
                    onlyNumbers
                    isLeadingZero={false}
                    maxLength={NTN_MAX_LENGTH}
                    error={{ text: ntnError, show: Boolean(ntnError) }}
                  />
                </Box>
              ) : null}

              <UBButton
                id="account_limit_next_btn"
                title={I18n.next}
                iconComponent={<EnterIcon />}
                iconPlacement="right"
                loading={loadingIncreaseLimit}
                disabled={isDisabled || Boolean(ntnError)}
                className={`buttonPrimary saveSaleButton textUppercase ${styles.nextBtn}`}
                onClick={onSubmit}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default IncreaseLimitForm;
